import axios from 'axios';

export type Query = {
  firebaseClass: string;
} & ({ householdNumbers: string | { $in: string[] } } | { _id: string });
type Data = {
  /**
   * @description 標題
   */
  title: string;
  /**
   * @description 內容
   */
  content: string;
  /**
   * @description 服務類別
   */
  class: string;
  /**
   * @description 重新導向頁面
   */
  redirect: string;
  /**
   * @description 傳送對象
   * @example
   * {
   *  firebaseClass: '某某服務', // 服務內容中文名稱
   *  householdNumbers: '123456789' // 戶號
   * }
   * ||
   * {
   *  firebaseClass: '某某服務', // 服務內容中文名稱
   * _id: '123456789' // 特定user id
   * }
   */
  query: Query;
  /**
   * @description 洽後端
   * @default 'message'
   */
  service?: string;
  /**
   * @description 洽後端
   * @default 'msg'
   */
  event?: string;
  /**
   * @description 訊息類型
   * @default 'success'
   */
  type?: string;
  /**
   * @description 訊息持續時間
   * @default 8000
   */
  duration?: number;
};

const sendNotification = async (data: Data) => {
  await axios.post(
    '/ezcon/api/emitMsgQuery',
    {
      service: 'message',
      event: 'msg',
      type: 'success',
      duration: 8000,
      ...data,
    },
    {
      headers: {
        authorization: window.localStorage['feathers-jwt'],
      },
    }
  );
};

export default sendNotification;
